module.exports = __webpack_public_path__ + "static/media/6.3c011515.jpg";